export default __webpack_public_path__ + "static/media/logo_xplore_orizzontale_bianco.cd9a8319.png";